<template>
  <div id="app" class="find-password">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>
<style lang='less' scoped>
.find-password{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// module/forgetPassword/src/App.vue